import React from 'react';
function Navigation() {
    return <nav name='navbar' className="navbar navbar-expand navbar-dark bg-transparent">
        <a className="navbar-brand" href="/">
            <img src="/images/logo-icon.png" className="logo" alt="logo" /> Rodosto Software Ltd
        </a>
    </nav>
}

export default Navigation;